import React from 'react'

class Close extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
        <g fill="#FFF" fillRule="nonzero">
          <path d="M5.1 23.485L23.486 5.101 24.9 6.515 6.515 24.899z" />
          <path d="M6.515 5.1l18.384 18.385-1.414 1.414L5.101 6.515z" />
        </g>
      </svg>
    )
  }
}

export default Close
